import script from "./ChatSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebar.vue?vue&type=style&index=0&id=a15d8ecc&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a15d8ecc"]])

export default __exports__